[
  {
    "family": "Griun Gowoon",
    "weight": "400",
    "url": "/fonts/griun.ttf",
    "bytes": 1449848
  },
  {
    "family": "BR Wakaisho",
    "weight": "400",
    "url": "/fonts/br-wakaisho-400.woff2",
    "bytes": 58484
  },
  {
    "family": "BR Wakaisho",
    "weight": "700",
    "url": "/fonts/br-wakaisho-700.woff2",
    "bytes": 58896
  },
  {
    "family": "Alex Brush",
    "weight": "400",
    "url": "/fonts/alexbrush.woff2",
    "bytes": 15212
  },
  {
    "family": "KoPubWorld Batang",
    "weight": "400",
    "url": "/fonts/kopub-400.woff2",
    "bytes": 80596
  },
  {
    "family": "KoPubWorld Batang",
    "weight": "700",
    "url": "/fonts/kopub-700.woff2",
    "bytes": 78816
  }
]
